import list from 'src/modules/foodOperator/list/foodOperatorListReducers';
import form from 'src/modules/foodOperator/form/foodOperatorFormReducers';
import view from 'src/modules/foodOperator/view/foodOperatorViewReducers';
import destroy from 'src/modules/foodOperator/destroy/foodOperatorDestroyReducers';
import importerReducer from 'src/modules/foodOperator/importer/foodOperatorImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
